import { Action } from '@ngrx/store';
import {
  EmployerSearchRequest,
  IEmployerResponse
} from 'src/app/core/services/peopleapi/peoplefunctionapi.services';

// Declaring an enum
export enum MaintenanceActionTypes {
  LoadSearchEmployer = '[Employer] Load Search Employer',
  LoadSearchEmployerSuccess = '[Employer] Load Search Employer Success',
  LoadSearchEmployerFail = '[Employer] Load Search Employer Fail',
}

export class LoadSearchEmployer implements Action {
  readonly type = MaintenanceActionTypes.LoadSearchEmployer;
  constructor(public searchParam: EmployerSearchRequest) { }
}

export class LoadSearchEmployerSuccess implements Action {
  readonly type = MaintenanceActionTypes.LoadSearchEmployerSuccess;
  constructor(public payload: IEmployerResponse[]) { }
}

export class LoadSearchEmployerFail implements Action {
  readonly type = MaintenanceActionTypes.LoadSearchEmployerFail;
  constructor(public payload: string) { }
}

// Union of all actions. | can be read as Or
export type MaintenanceActions =
LoadSearchEmployer |
LoadSearchEmployerSuccess|
 LoadSearchEmployerFail
;
